import styled from 'styled-components';

export const StyledNewslettersList = styled.ul`
    padding: 100px 10px;
`